import React from 'react';

interface CloseIconProps {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

export const CloseIcon: React.FC<CloseIconProps> = ({ fill = '#626266', width = 14, height = 14 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7377 5.26243C18.3881 4.91252 17.8442 4.91252 17.4953 5.26243L12 10.7616L6.50466 5.26243C6.15499 4.91252 5.61115 4.91252 5.26225 5.26243C4.91258 5.61235 4.91258 6.15657 5.26225 6.5057L10.7576 12.0048L5.26225 17.504C4.91258 17.8539 4.91258 18.3981 5.26225 18.7472C5.43671 18.9218 5.6506 19 5.88346 19C6.11631 19 6.33021 18.9226 6.50466 18.7472L12 13.2481L17.4953 18.7472C17.6698 18.9218 17.8837 19 18.1165 19C18.3494 19 18.5633 18.9226 18.7377 18.7472C19.0874 18.3973 19.0874 17.8531 18.7377 17.504L13.2424 12.0048L18.7377 6.5057C19.0677 6.15579 19.0677 5.61233 18.7377 5.26243Z"
      fill={fill}
    />
  </svg>
);
